import type {AdminOrderDetail} from "@corporatesclub/shared";
import {Button} from "@/components/ui/button";
import {AdminBadge} from "../ui/AdminBadge";
import {AdminStatusBadge} from "../ui/AdminStatusBadge";

const STATUS_OPTS = [
  {v: 1, l: "Processing"},
  {v: 2, l: "Shipped"},
  {v: 3, l: "Delivered"},
  {v: 4, l: "Cancelled"},
  {v: 5, l: "Paid"},
  {v: 6, l: "Payment error"},
  {v: 7, l: "Ready"}
];
const STATUS_BTNS = [1, 5, 6, 7, 2, 3, 4];

type Props = {
  detail: AdminOrderDetail;
  onApplyStatus: (id: number, op: string, label: string) => void;
};

export function OrderStatusBar({detail, onApplyStatus}: Props) {
  return (
    <div className="space-y-3.5">
      <div className="flex flex-wrap items-center gap-2">
        <AdminStatusBadge status={detail.status}>{detail.statusLabel}</AdminStatusBadge>
        {detail.confirmed ? <AdminStatusBadge tone="draft">Confirmed</AdminStatusBadge> : null}
        {detail.guest ? <AdminBadge variant="outline">Guest</AdminBadge> : null}
      </div>

      {detail.status !== 4 ? (
        <div className="flex flex-wrap gap-1.5">
          {STATUS_BTNS.map((s) => {
            const label = STATUS_OPTS.find((x) => x.v === s)?.l || "";
            const active = detail.status === s;
            return (
              <Button
                key={s}
                type="button"
                variant={active ? "default" : "outline"}
                size="sm"
                className="h-7 rounded-full px-2.5 text-[11px] font-medium"
                onClick={() => onApplyStatus(detail.id, `status${s}`, label)}
              >
                {label}
              </Button>
            );
          })}
          {!detail.confirmed ? (
            <Button
              type="button"
              size="sm"
              className="h-7 rounded-full px-2.5 text-[11px] font-medium"
              onClick={() => onApplyStatus(detail.id, "statusConfirmata", "Confirm order")}
            >
              Confirm order
            </Button>
          ) : null}
        </div>
      ) : (
        <p className="text-xs text-muted-foreground">Order cancelled — status locked.</p>
      )}
    </div>
  );
}
